import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';
import '../styles/HeroSection.css';

const HeroSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="home" className="hero-section">
      <div className="hero-content">
        <div className="hero-badge">Layer 3 on Base</div>
        <h1>{t.headline}</h1>
        <p>{t.subheadline}</p>
        <div className="cta-buttons">
        <a href="https://github.com/YourGitHubUsername/BankL" target="_blank" rel="noopener noreferrer" className="cta-button primary">
            🚀 {t.launchApp}
          </a>
          <button className="cta-button secondary">📝 {t.readDocs}</button>
          <button className="cta-button secondary">📬 {t.joinWaitlist}</button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;